/*
 * ---------------------------------------------------------------------------------
 * Copyright:
 *      NewtonGreen Technologies Pty. Ltd.
 *      Level 4, 175 Scott St.
 *      Newcastle, NSW, 2300
 *      Australia
 *
 *      E-mail: support@newtongreen.com
 *      Tel: (02) 4925 5288
 *      Fax: (02) 4925 3068
 *
 *      All Rights Reserved.
 * ---------------------------------------------------------------------------------
 */

/*
 * ---------------------------------------------------------------------------------
 * This file contains the component that provides context for the online patient
 * management system.
 * ---------------------------------------------------------------------------------
 */

/*
 * ----------------------------------------------------------------------------------
 * Imports - External
 * ----------------------------------------------------------------------------------
 */

/*
 * Required to use React components.
 */
import { GridColDef } from '@material-ui/data-grid';
import * as React from 'react';
/*
 * ---------------------------------------------------------------------------------
 * Imports - Internal
 * ---------------------------------------------------------------------------------
 */

import LabelsContext, { IFormLabel } from '../../../contexts/form/LabelsContext';


import CollapsibleTable from '../../table/CollapsibleTable';
import Markdown from '../../utility/Markdown';

/*
 * ---------------------------------------------------------------------------------
 * Interfaces
 * ---------------------------------------------------------------------------------
 */

/**
 * This interface defines the properties for the FormValues component.
 */
export interface IFormLabelsProps {

}

/*
 * ---------------------------------------------------------------------------------
 * Components
 * ---------------------------------------------------------------------------------
 */
const columns: GridColDef[] = [
    {
        field: 'name',
        headerName: 'Property Path',
        flex: 1
    },
    {
        field: 'label',
        headerName: 'Label',
        flex: 1
    }    
]

/**
 * This component provides context for the patient management system.
 * @param param0 component properties.
 */
const FormLabels: React.FunctionComponent<IFormLabelsProps> = ({
    children
}) => {
    const labels = React.useContext(LabelsContext);

    const data = React.useMemo(() => {
        return labels?.map((d, i) => ({ id: i, ...d }));
    }, [labels])

    return (
        <CollapsibleTable
            title="Labels"
            loading={false}
            rows={data ?? []}
            columns={columns}
            startCollapsed
            autoHeight
        />
    );
}

/*
 * ---------------------------------------------------------------------------------
 * Default Export
 * ---------------------------------------------------------------------------------
 */

export default FormLabels;